import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  moreTo,
  moreLabel = "查看全部",
  action,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 md:mb-6">
      <div>
        {eyebrow && (
          <div className="mb-1.5 flex items-center gap-2">
            <span className="h-3 w-1 rounded-full bg-accent-500" />
            <span className="font-label text-xs font-semibold uppercase tracking-[0.18em] text-accent-700">
              {eyebrow}
            </span>
          </div>
        )}
        <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">{title}</h2>
        {desc && <p className="mt-1.5 text-sm text-foreground-600">{desc}</p>}
      </div>
      {action}
      {moreTo && !action && (
        <Link
          to={moreTo}
          className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      )}
    </div>
  );
}